import { css } from '@emotion/core';

const styles = {
  actionsContainer: css`
    width: 100%;
    & .MuiButton-contained {
      // exact padding of text variant button.
      margin-bottom: 12px;
    }
  `,
};

export default styles;
